import { ReactNode, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

import { COLORS } from 'consts';
import { useTheme } from 'context/theme';

type useClampTextParams = {
  lines?: number;
  text: ReactNode;
  ellipsis?: ReactNode;
  ellipsisClassName?: string;
};

export const useClampText = ({ lines = 3, text, ellipsisClassName, ellipsis = '...' }: useClampTextParams) => {
  const [lineHeight, setLineHeight] = useState(0);
  const [totalHeight, setTotalHeight] = useState(0);
  const { isDark } = useTheme();
  const textRef = useRef<HTMLDivElement>(null);

  const showEllipsis = totalHeight > lineHeight * lines;

  useEffect(() => {
    const handleResize = () => {
      if (!textRef?.current) {
        return;
      }
      const lineHeightValue = parseInt(window.getComputedStyle(textRef.current).lineHeight);

      if (!isNaN(lineHeightValue)) {
        setLineHeight(lineHeightValue);
      }
      setTotalHeight(textRef.current.scrollHeight);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className='position-relative'>
      <div
        ref={textRef}
        className='overflow-hidden'
        style={{
          maxHeight: lineHeight * lines
        }}
      >
        {text}
      </div>
      {showEllipsis && (
        <div
          className={classNames('position-absolute ps-1 end-0 bottom-0', ellipsisClassName)}
          style={{
            zIndex: 2,
            backgroundColor: isDark ? COLORS.primaryDark : COLORS.primaryLight,
            color: isDark ? COLORS.primaryLight : COLORS.primaryDark
          }}
        >
          {ellipsis}
        </div>
      )}
    </div>
  );
};
